import ConfigService from "../../../shared/services/configService";
import { TEXT } from "../../../shared/constants/texts";
import { apiCall, apiCallRefreshToken } from "./slice";

const configService = new ConfigService();

export const validateTokenApiCall = ({ dispatch, history, requestData }) => {
  const baseUrl = configService.getApiUrl().toString();
  return dispatch(
    apiCall({
      requestBaseUrl: baseUrl,
      requestUrl: `User/ValidateUserApiToken`,
      requestMethod: TEXT.POST,
      requestData: requestData,
      history: history,
    })
  );
};

export const getIdpTokenApiCall = ({ dispatch, history, requestData }) => {
  return dispatch(
    apiCall({
      requestBaseUrl: window.location.origin,
      requestUrl: "/Auth/ReturnAuthToken",
      requestMethod: TEXT.POST,
      requestData: requestData,
      history: history,
    })
  );
};

export const getIdpTokenFromRefreshTokenApiCall = ({ dispatch, history, requestData }) => {
  return dispatch(
    apiCall({
      requestBaseUrl: window.location.origin,
      requestUrl: "/Auth/ReturnAuthToken",
      requestMethod: TEXT.POST,
      requestData: requestData,
      history: history,
    })
  );
};

export const getIcmTokenFromRefreshTokenApiCall = ({ dispatch, history, requestData }) => {
  const nonDefaultBaseUrl = configService.getApiUrl().toString().replace("serviceapi/", "");
  return dispatch(
    apiCallRefreshToken({
      requestBaseUrl: nonDefaultBaseUrl,
      requestUrl: "/api/AuthToken/RefreshToken",
      requestMethod: TEXT.POST,
      requestData: requestData,
      history: history,
    })
  );
};

export const revokeIcmAuthTokenApiCall = ({ dispatch, history, requestData }) => {
  const nonDefaultBaseUrl = configService.getApiUrl().toString().replace("serviceapi/", "");
  return dispatch(
    apiCallRefreshToken({
      requestBaseUrl: nonDefaultBaseUrl,
      requestUrl: "/api/AuthToken/RevokeToken",
      requestMethod: TEXT.POST,
      requestData: requestData,
      history: history,
    })
  );
};
